import axios from 'axios'
import qs from 'qs'
import { VueAxios } from './axios'


const base = '//devapi.cyzone.cn';

// 创建 axios 实例
axios.defaults.withCredentials = true;
const service = axios.create({
  timeout: 6000, // 请求超时时间
  withCredentials: true
})


// request interceptor
// service.interceptors.request.use(config => {
//   return config
// }, err)

// response interceptor
// service.interceptors.response.use((response) => {
//   return response
// }, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

const generateRequest = (method, url, params = {}, isWhite = false) => {

  switch (method.toLowerCase()) {
    case 'get':
      return axios.get(url, {
        params: params
      }).then(res => res.data)
    case 'post':
      return axios.post(url, qs.stringify(params)).then(res => res.data)
    default:
      return axios[method.toLowerCase()](url, {
        params: params
      }).then(res => res.data);
      break
  }
}

export {
  installer as VueAxios,
  service as axios,
  base,
  generateRequest
}



// WEBPACK FOOTER //
// ./src/utils/request.js